var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8613 0.403344C16.0123 0.19408 17.0723 1.07825 17.0723 2.24807V2.83596C17.8192 3.26829 18.3223 4.07586 18.3223 5.001V17.501C18.3223 18.8816 17.2028 20.0008 15.8223 20.001H5.82227C5.06937 20.001 4.39388 19.6682 3.93555 19.1416C3.56108 18.8014 3.32227 18.3097 3.32227 17.7539V4.06545C3.32246 3.15949 3.96995 2.38283 4.86133 2.22073L14.8613 0.403344ZM7.69727 15.001C7.3521 15.001 7.07228 15.2808 7.07227 15.626C7.07227 15.9712 7.35209 16.251 7.69727 16.251H13.9473C14.2923 16.2508 14.5723 15.971 14.5723 15.626C14.5723 15.281 14.2923 15.0012 13.9473 15.001H7.69727ZM10.8223 6.251C8.75121 6.251 7.07228 7.92994 7.07227 10.001C7.07227 12.0721 8.7512 13.751 10.8223 13.751C12.8932 13.7508 14.5723 12.0719 14.5723 10.001C14.5723 7.93007 12.8931 6.25121 10.8223 6.251ZM10.8223 7.501C12.2028 7.50121 13.3223 8.62043 13.3223 10.001C13.3223 11.3816 12.2028 12.5008 10.8223 12.501C9.44155 12.501 8.32227 11.3817 8.32227 10.001C8.32228 8.6203 9.44156 7.501 10.8223 7.501Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.a89c4486f2bc15e75b608983954660ff.svg";
export { ForwardRef as ReactComponent };